exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".defaultShadows {\n    -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, .175);\n    box-shadow: 0 6px 12px rgba(0, 0, 0, .175);\n    -moz-box-shadow: 0 6px 12px rgba(0, 0, 0, .175);\n    -o-box-shadow: 0 6px 12px rgba(0, 0, 0, .175);\n}\n\n.textDefaultShadows {\n    text-shadow: 0 6px 12px rgba(0, 0, 0, .175);\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./client/css/shadows.css
// module id = 90
// module chunks = 0